import { Component, OnInit } from '@angular/core';
import { HeadwordSearchService } from '../services/headword-search.service';
import { NavigationService } from '../services/navigation.service';

@Component({
  selector: 'app-paragraph-search',
  templateUrl: './paragraph-search.component.html',
  styleUrls: ['./paragraph-search.component.scss'],
})
export class ParagraphSearchComponent implements OnInit {
  paragraph = '';
  wordCheckArray:boolean[] = [];
  showResult=false;
  paraWords:string[];

  constructor(private headWordSearch: HeadwordSearchService, public navigationService: NavigationService) {
   }

  ngOnInit() {}

  async paraSearch(){
    this.wordCheckArray =[];
    let re = /[\s, \.]+/;
  
    this.paraWords = this.paragraph.split(re);
    console.log(this.paraWords); 

    for (let index in this.paraWords) {
      this.wordCheckArray.push(await this.headWordSearch.includes(this.paraWords[index]).toPromise());
      
    }

    this.showResult=true;
    console.log(this.wordCheckArray); 

  }

  async clearSearch(){
    this.showResult=false;
    this.paragraph = '';
  }


}
